import script from "./DataManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DataManager.vue?vue&type=script&setup=true&lang=js"

import "./DataManager.vue?vue&type=style&index=0&id=14beaeca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14beaeca"]])

export default __exports__